import React from "react";

const Footer = () => {
  return (
    <footer className="bg-blue-900 text-white py-4">
      <div className="container mx-auto px-6 lg:px-12 flex flex-col lg:flex-row justify-between items-center">
        {/* Left side */}
        <p className="text-sm text-center lg:text-left">
          ©2024 Smart Nexus Solutions. All Rights Reserved.
        </p>

        {/* Right side */}
        <div className="mt-4 lg:mt-0 flex space-x-4 text-sm">
          <a href="/privacy-policy" className="hover:text-gray-300">
            Privacy Policy
          </a>
          <a href="/terms-and-conditions" className="hover:text-gray-300">
            Terms and Conditions
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
